import * as React from "react"
import { cn } from "../../lib/utils"

interface SectionHeadingProps {
  label?: string
  title: string
  description?: string
  variant?: 'light' | 'dark'
  className?: string
}

const SectionHeading: React.FC<SectionHeadingProps> = ({
  label,
  title,
  description,
  variant = 'dark',
  className,
}) => (
  <div className={cn("text-center mb-20", className)}>
    {label && (
      <p className={cn(
        "text-sm font-semibold tracking-[0.15em] uppercase mb-4",
        variant === 'dark' ? "text-purple-400" : "text-purple-600"
      )}>
        {label}
      </p>
    )}
    <h2 className={cn(
      "text-3xl lg:text-5xl font-bold tracking-[-0.02em] mb-5",
      variant === 'dark' ? "text-white" : "text-gray-900"
    )}>
      {title}
    </h2>
    {description && (
      <p className={cn(
        "text-lg max-w-xl mx-auto leading-relaxed",
        variant === 'dark' ? "text-white/40" : "text-gray-500"
      )}>
        {description}
      </p>
    )}
  </div>
)

export { SectionHeading }
